/**
 * @param {import('konva/lib/Layer').Layer} designLayer
 * @param {string[]} annotationIds
 */
const getMultiSelectionClientRects = (designLayer, annotationIds) => {
  if (!designLayer?.findOne) {
    return [];
  }

  return annotationIds
    .map((id) => {
      const node = designLayer.findOne(`#${id}`);
      if (!node) {
        return null;
      }
      const rect = node.getClientRect({ relativeTo: designLayer });
      return {
        id,
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
      };
    })
    .filter(Boolean);
};

export default getMultiSelectionClientRects;
